import autoMapper from './automapper';
import order from './order';
function timestampToTime(timestamp, hasSecond = true) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D =
    date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var s =
    ":" +
    (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
  if (hasSecond) {
    return Y + M + D + h + m + s;
  } else {
    return Y + M + D + h + m;
  }
}
// 2019-6-24
function timestampToDay(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D =
    date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
  return Y + M + D;
}

/**
 * 时间戳 => 10-10
 * */
function timestampToMD(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + ".";
  var D =
    (date.getDate() + 1 < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  return M + D;
}

/**
 * 时间戳 => 10:10
 * */

function timestampToHM(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var h =
    (date.getHours() + 1 < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    date.getMinutes() + 1 < 10 ? "0" + date.getMinutes() : date.getMinutes();
  // var s = (date.getSeconds() + 1 < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return h + m;
  // return Y + M + D;
}

/**
 * 时间戳 =>判断时间戳区间（ 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年 ）
 * */
function time_judge(time_start, time_end) {
  var time_s = new Date(time_start * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var time_e = new Date(time_end * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var today = new Date(); //当前时间
  var Y_s = time_s.getFullYear() + ".";
  var Y_e = time_e.getFullYear() + ".";
  var Y_n = today.getFullYear() + ".";
  var M_s =
    (time_s.getMonth() + 1 < 10
      ? "0" + (time_s.getMonth() + 1)
      : time_s.getMonth() + 1) + ".";
  var M_e =
    (time_e.getMonth() + 1 < 10
      ? "0" + (time_e.getMonth() + 1)
      : time_e.getMonth() + 1) + ".";
  var D_s =
    (time_s.getDate() + 1 < 10 ? "0" + time_s.getDate() : time_s.getDate()) +
    " ";
  var D_e =
    (time_e.getDate() + 1 < 10 ? "0" + time_e.getDate() : time_e.getDate()) +
    " ";
  //判断
  if (Y_s == Y_e) {
    //同年
    if (Y_s == Y_n) {
      //今年
      if (M_s == M_e && D_s == D_e) {
        //今年不跨日
        return 0;
      } else {
        //今年跨日
        return 1;
      }
    } else {
      //往年
      if (M_s == M_e && D_s == D_e) {
        //往年不跨日
        return 2;
      } else {
        //往年跨日
        return 3;
      }
    }
  } else {
    //跨年
    return 4;
  }
}

// 获取时间跨度
function getDuration(start_date, end_date) {
  let dateStr;
  // 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年
  const type = time_judge(start_date, end_date);
  switch (type) {
    case 0:
      {
        dateStr =
          timestampToMD(start_date) +
          timestampToHM(start_date) +
          " - " +
          timestampToHM(end_date);
      }
      break;
    case 1:
      {
        dateStr =
          timestampToMD(start_date) +
          timestampToHM(start_date) +
          " - " +
          timestampToMD(end_date) +
          timestampToHM(end_date);
      }
      break;
    case 2:
      {
        dateStr =
          timestampToDay(start_date) +
          timestampToHM(start_date) +
          " - " +
          timestampToHM(end_date);
      }
      break;
    case 3:
      {
        dateStr =
          timestampToDay(start_date) +
          timestampToHM(start_date) +
          " - " +
          timestampToMD(end_date) +
          timestampToHM(end_date);
      }
      break;
    case 4:
      {
        dateStr =
          timestampToDay(start_date) +
          timestampToHM(start_date) +
          " - " +
          timestampToDay(end_date) +
          timestampToHM(end_date);
      }
      break;
    default:
      dateStr = "不支持的时间格式";
      break;
  }
  return dateStr;
}

function toPaperStatus(_status) {
  if (_status == 1) {
    return "启用";
  } else if (_status == 2) {
    return "禁用";
  } else {
    return "-";
  }
}

function toQuestionType(_type) {
  if (_type == 1) {
    return "单选题";
  } else if (_type == 2) {
    return "多选题";
  } else if (_type == 3) {
    return "判断题";
  } else {
    return "-";
  }
}

function toTaskStatus(_status) {
  if (_status == 1) {
    return "已完成";
  } else if (_status == 2) {
    return "未完成";
  } else if (_status == 3) {
    return "未开始";
  } else {
    return "-";
  }
}

function toTrainStatus(_status) {
  if (_status == 1) {
    return "进行中";
  } else if (_status == 2) {
    return "未开始";
  } else if (_status == 3) {
    return "已结束";
  } else if (_status == 4) {
    return "已发布";
  } else if (_status == 5) {
    return "未发布";
  } else if (_status == 6) {
    return "已撤回";
  } else {
    return "-";
  }
}

function toCourseType(_type) {
  if (_type == 1) {
    return "视频";
  } else if (_type == 2) {
    return "音频";
  } else if (_type == 3) {
    return "图文";
  } else {
    return "-";
  }
}

function toArray(obj, _id = "id", _value = "value") {
  let arr = [];
  for (let i in obj) {
    let item = {};
    item[_id] = i;
    item[_value] = obj[i];
    arr.push(item);
  }
  return arr;
}

function mate(aim, all, _id = "id", _value = "value") {
  let value = [];
  if (!aim) {
    return;
  }
  let arr = aim.split(",");
  for (let i = 0; i < arr.length; i++) {
    let current = arr[i];
    for (let j = 0; j < all.length; j++) {
      if (current == all[j][_value]) {
        value.push(all[j][_id]);
        break;
      }
    }
  }
  return value;
}

// 计算价格
function calcPrice(price) {
  if (!price) price = 0;
  return (price / 100).toFixed(2);
}

// 数组元素交换
function swapArrayItem(arr, fromIndex, toIndex) {
  arr[toIndex] = arr.splice(fromIndex, 1, arr[toIndex])[0];
  return arr;
}

// 数组转","分隔的字符串
function splitStr(arr, attr, cut = ",") {
  let str = "";
  arr &&
    arr.length &&
    arr.forEach(item => {
      str += item[attr] + cut;
    });
  str = str.substr(0, str.length - 1);
  return str;
}

// 获取优惠券使用范围描述
function getCouponUseRange(disType, scopeType, commodity) {
  let ret = "";
  switch (disType) {
    case 1: // 班课
      if (scopeType == 1) {
        ret = "班课 / 全部课程";
      } else if (scopeType == 2) {
        ret =
          "班课 / 指定分类" +
          (commodity ? " / " + splitStr(commodity, "title") : "");
      } else if (scopeType == 3) {
        ret =
          "班课 / 指定课程" +
          (commodity ? " / " + splitStr(commodity, "title") : "");
      }
      break;
    case 4: // 一对一
      if (scopeType == 1) {
        ret = "一对一 / 全部约课";
      } else if (scopeType == 2) {
        ret =
          "一对一 / 指定约课讲师" +
          (commodity ? " / " + splitStr(commodity, "title") : "");
      }
      break;
    case 2: // 图书
      if (scopeType == 1) {
        ret = "图书 / 全部图书";
      } else if (scopeType == 2) {
        ret =
          "图书 / 指定分类" +
          (commodity ? " / " + splitStr(commodity, "title") : "");
      } else if (scopeType == 3) {
        ret =
          "图书 / 指定图书" +
          (commodity ? " / " + splitStr(commodity, "title") : "");
      }
      break;
    case 3:
      ret = "文库";
      break;
  }
  return ret;
}
// 将对象第一级属性全部重置为空字符串
// obj - 待处理对象     exceptKeyAry - 排除的键值数组    val - 重置的值
function clearObj(obj, exceptKeyAry = [], val = "") {
  for (const key in obj) {
    if (exceptKeyAry.includes(key)) continue;
    obj[key] = val;
  }
}

function downloadFile(url, fileName) {
  if (url.indexOf("?") < 0) {
    url += "?";
  } else {
    url += "&";
  }
  let xhr = new XMLHttpRequest();
  xhr.open("get", url + new Date().getTime());
  xhr.responseType = "blob";
  xhr.onreadystatechange = () => {
    if (xhr.readyState == 4 && xhr.status == 200) {
      let blob = xhr.response;
      let blobUrl = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      link.click();
    }
  };
  xhr.send();
}


export default {
  timestampToTime,
  timestampToDay,
  timestampToMD,
  timestampToHM,
  time_judge,
  getDuration,
  toPaperStatus,
  toQuestionType,
  toTaskStatus,
  toTrainStatus,
  toCourseType,
  toArray,
  mate,
  calcPrice,
  swapArrayItem,
  splitStr,
  getCouponUseRange,
  autoMapper,
  order,
  downloadFile,
  clearObj
};
